module.exports = __webpack_public_path__ + "static/media/IconPaymentFail.a0a216e0.svg";